export enum OrganizationMenuRoute {
  Profile = 'profile',
  DetailsAndNotes = 'details-and-notes',
  UserManagement = 'users',
  LicensePlan = 'license-plan',
  DataRetention = 'data-retention',
  Alerts = 'alerts',
  Tasks = 'tasks',
  Brand = 'brand',
}
